<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="fluid pt-0 mb-4">
      <v-card class="green lighten-1">
        <v-card-text>
          <v-container grid-list-lg pa-0>                      
            <v-layout wrap row>
              <v-flex sm4 xs12>
                <v-autocomplete
                  solo clearable
                  v-bind:items="areas"
                  v-bind:search-input.sync="areaSearch"
                  v-bind:filter="customFilter"                                        
                  item-text="name"
                  item-value="id"
                  v-model="area_id"                                        
                  label="Search Kecamatan" 
                  v-bind:loading="areaLoading"
                  hide-details hide-no-data 
                ></v-autocomplete>
              </v-flex>
              <v-flex sm8 xs12>
                <v-select
                  v-model="kompetisi_ids"
                  v-bind:items="kompetisis"
                  item-text="name"
                  item-id="id"
                  chips
                  label="Kompetisi"
                  v-bind:loading="kompetisiLoading"
                  multiple
                  solo
                  hide-details
                ></v-select> 
              </v-flex>
            </v-layout>                               
          </v-container>  
        </v-card-text>
      </v-card>
      <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>                  
      <v-card class="mt-3">
        <v-toolbar>
          <v-icon color="success" large>blur_linear</v-icon>
          <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
            <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
            ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="downloadExcel" :disabled="result.length === 0"><v-icon left>move_to_inbox</v-icon> Download .xlxs</v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-expansion-panel v-model="panel" flat class="elevation-0 ma-0" expand>
            <v-expansion-panel-content v-for="(item, i) in result" v-bind:key="i" :style="'color:#fff;background:'+item.color" class="lighten-2">
              <div slot="header" dark>Sheet {{i+1}} : {{item.name}}</div>
              <v-card>
                <v-card-text class="pa-0 mb-1 v-table__overflow">                  
                  <table class="report" :name="item.name">            
                    <tbody>
                      <tr>
                        <th :colspan="item.area.length+4">MODEL DA1 {{item.name}}</th>
                      </tr>                      
                      <tr>
                        <td colspan="2">KOMPETISI</td><td>{{item.name}}</td>                        
                        <td :rowspan="item.dapil?5:4" style="font-size:40px">DA1                          
                        </td>
                        <td :colspan="item.area.length"></td>
                      </tr>
                      <tr v-if="item.dapil">
                        <td colspan="2">DAPIL</td><td>{{item.dapil.no}} {{item.dapil.name}}</td>                                                
                        <td :colspan="item.area.length"></td>
                      </tr>
                      <tr>
                        <td colspan="2">PROVINSI</td><td>{{item.provinsi}}</td><td :colspan="item.area.length"></td>
                      </tr>
                      <tr>
                        <td colspan="2">KABUPATEN/KOTA</td><td>{{item.kota}}</td><td :colspan="item.area.length"></td>
                      </tr>
                      <tr>
                        <td colspan="2">KECAMATAN</td><td>{{item.kecamatan.name}}</td><td :colspan="item.area.length"></td>
                      </tr>                                           
                      <tr><td :colspan="item.area.length + 4"></td></tr>
                      <tr>
                        <th rowspan="2" colspan="2">NO.</th><th rowspan="2">Uraian</th><th rowspan="2">TOTAL</th><th :colspan="item.area.length">WILAYAH</th>                       
                      </tr>
                      <tr>
                        <th v-for="(area) in item.area">{{area.name}}</th>
                      </tr>
                      <tr><td>I.</td><td :colspan="item.area.length+3"><strong>Data Pemilih dan Penggunaan Hak Pilih</strong></td></tr>                      
                      <tr><td></td><td :colspan="item.area.length+3">A. DATA PEMILIH</td></tr>
                      <tr>
                        <td></td><td>1</td><td>Pemilih terdaftar dalam Daftar Pemilih Tetap (DPT)</td><td>{{dpt = item.kecamatan.sah.dpt?item.kecamatan.sah.dpt:0}}</td><td v-for="(tps) in item.area">{{tps.sah.dpt?tps.sah.dpt:0}}</td>
                      </tr>                      
                      <tr>
                        <td></td><td>2</td><td>Pemilih dari Daftar Pemilih Tambahan (DPTb)</td><td>{{dptb = item.kecamatan.sah.dptb?item.kecamatan.sah.dptb:0}}</td><td v-for="(tps) in item.area">{{tps.sah.dptb?tps.sah.dptb:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>3</td><td>Pemilih terdaftar dalam Daftar Pemilih Khusus (DPK)</td><td>{{dpph = item.kecamatan.sah.dpph?item.kecamatan.sah.dpph:0}}</td><td v-for="(tps) in item.area">{{tps.sah.dpph?tps.sah.dpph:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>4</td><td>Jumlah Pemilih (1+2+3)</td><td>{{ parseInt(dpt)+ parseInt(dpph)+ parseInt(dptb)}}</td><td v-for="(tps) in item.area">{{parseInt(tps.sah.dpt?tps.sah.dpt:0)+parseInt(tps.sah.dpph?tps.sah.dpph:0)+parseInt(tps.sah.dptb?tps.sah.dptb:0)}}</td>
                      </tr>
                      <tr><td></td><td :colspan="item.area.length+3">B. PENGGUNA HAK PILIH</td></tr>
                      <tr>
                        <td></td><td>1</td><td>Penggunaan hak pilih dalam Daftar Pemilih Tetap (DPT)</td><td>{{pen_dpt = item.kecamatan.sah.pen_dpt?item.kecamatan.sah.pen_dpt:0}}</td><td v-for="(tps) in item.area">{{tps.sah.pen_dpt?tps.sah.pen_dpt:0}}</td>
                      </tr>                      
                      <tr>
                        <td></td><td>2</td><td>Penggunaan hak pilih dalam Daftar Pemilih Tambahan (DPTb)</td><td>{{pen_dptb = item.kecamatan.sah.pen_dptb?item.kecamatan.sah.pen_dptb:0}}</td><td v-for="(tps) in item.area">{{tps.sah.pen_dptb?tps.sah.pen_dptb:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>3</td><td>Penggunaan hak pilih dalam Daftar Pemilih Khusus (DPK)</td><td>{{pen_dpph = item.kecamatan.sah.pen_dpph?item.kecamatan.sah.pen_dpph:0}}</td><td v-for="(tps) in item.area">{{tps.sah.pen_dpph?tps.sah.pen_dpph:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>4</td><td>Jumlah seluruh pengguna hak pilih (1+2+3)</td><td>{{parseInt(pen_dpt) + parseInt(pen_dpph) + parseInt(pen_dptb)}}</td><td v-for="(tps) in item.area">{{parseInt(tps.sah.pen_dpt?tps.sah.pen_dpt:0)+parseInt(tps.sah.pen_dpph?tps.sah.pen_dpph:0)+parseInt(tps.sah.pen_dptb?tps.sah.pen_dptb:0)}}</td>
                      </tr>
                      <tr><td>II.</td><td :colspan="item.area.length+3"><strong>Data Penggunaan Surat Suara</strong></td></tr>                      
                      <tr>
                        <td></td><td>1</td><td>Jumlah surat suara yang digunakan</td><td>{{digunakan = item.kecamatan.sah.digunakan?item.kecamatan.sah.digunakan:0}}</td><td v-for="(tps) in item.area">{{tps.sah.digunakan?tps.sah.digunakan:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>2</td><td>Jumlah surat suara yang tidak digunakan</td><td>{{tdk_digunakan = item.kecamatan.sah.tdk_digunakan?item.kecamatan.sah.tdk_digunakan:0}}</td><td v-for="(tps) in item.area">{{tps.sah.tdk_digunakan?tps.sah.tdk_digunakan:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>3</td><td>Jumlah surat suara yang dikembalikan pemilih karena rusak</td><td>{{rusak = item.kecamatan.sah.rusak?item.kecamatan.sah.rusak:0}}</td><td v-for="(tps) in item.area">{{tps.sah.rusak?tps.sah.rusak:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>4</td><td>Jumlah surat suara yang diterima termasuk cadangan 2% (1+2+3)</td><td>{{parseInt(digunakan)+parseInt(tdk_digunakan)+parseInt(rusak)}}</td><td v-for="(tps) in item.area">{{parseInt(tps.sah.digunakan?tps.sah.digunakan:0)+parseInt(tps.sah.tdk_digunakan?tps.sah.tdk_digunakan:0)+parseInt(tps.sah.rusak?tps.sah.rusak:0)}}</td>
                      </tr>
                      <tr>
                        <td>III.</td><td :colspan="item.area.length + 3"><strong>Data Jumlah Suara Sah dan Tidak Sah</strong></td></tr>                      
                      </tr>
                      <tr>
                        <td></td><td>1</td><td>Jumlah suara sah seluruh calon</td><td>{{sah = item.kecamatan.sah.sah?item.kecamatan.sah.sah:0}}</td><td v-for="(tps) in item.area">{{tps.sah.sah?tps.sah.sah:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>2</td><td>Jumlah suara tidak sah</td><td>{{tdk_sah = item.kecamatan.sah.tdk_sah?item.kecamatan.sah.tdk_sah:0}}</td><td v-for="(tps) in item.area">{{tps.sah.tdk_sah?tps.sah.tdk_sah:0}}</td>
                      </tr>
                      <tr>
                        <td></td><td>3</td><td>	Jumlah suara sah dan tidak sah (1+2)</td><td>{{parseInt(sah)+parseInt(tdk_sah)}}</td><td v-for="(tps) in item.area">{{parseInt(tps.sah.sah?tps.sah.sah:0)+parseInt(tps.sah.tdk_sah?tps.sah.tdk_sah:0)}}</td>
                      </tr>                                            
                      <tr><td>IV.</td><td :colspan="item.area.length+3"><strong>Data Jumlah Suara Per Calon</strong></td></tr>                      
                      <tr>
                        <th colspan="2" rowspan="2">No.</th><th rowspan="2">Nama Calon</th><th rowspan="2">Total Suara</th><th :colspan="item.area.length">WILAYAH</th>
                      </tr>
                      <tr>
                        <th v-for="(area) in item.area">{{area.name}}</th>
                      </tr>
                      <template v-for="(calon, i) in item.calons">
                        <tr v-if="!calon.parent_id">
                          <td :style="'color:#fff;background:'+calon.color">{{calon.no}}</td>
                          <td :style="'color:#fff;background:'+calon.color"></td>
                          <td :style="'color:#fff;background:'+calon.color">{{name = calon.name}}</td>
                          <td :style="'color:#fff;background:'+calon.color"><span style="display:none">{{total=quickcountMode ? parseInt(calon.hitung.quickcount ? calon.hitung.quickcount : 0) :parseInt(calon.hitung.suara?calon.hitung.suara:0)}}</span>{{quickcountMode ? parseInt(calon.hitung.quickcount ? calon.hitung.quickcount : 0) :parseInt(calon.hitung.suara?calon.hitung.suara:0)}}</td>
                          <td :style="'color:#fff;background:'+calon.color" v-for="(detail,j) in calon.detail">
                            {{quickcountMode ? (detail.quickcount ? detail.quickcount : 0) : (detail.suara?detail.suara:0)}}
                            <span style="display:none">{{totDetail[j] = quickcountMode ? parseInt(detail.quickcount ? detail.quickcount : 0) : parseInt(detail.suara?detail.suara:0)}}</span>
                          </td>
                        </tr>
                        <tr v-else>
                          <td></td>
                          <td>{{calon.no}}</td>
                          <td>{{calon.name}}</td>
                          <td><span style="display:none">{{total+= quickcountMode ? parseInt(calon.hitung.quickcount ? calon.hitung.quickcount : 0) : parseInt(calon.hitung.suara?calon.hitung.suara:0)}}</span>{{quickcountMode ? parseInt(calon.hitung.quickcount ? calon.hitung.quickcount : 0) :parseInt(calon.hitung.suara?calon.hitung.suara:0)}}</td>
                          <td v-for="(detail, j) in calon.detail">
                            {{quickcountMode ? (detail.quickcount ? detail.quickcount : 0) :(detail.suara?detail.suara:0)}}
                            <span style="display:none">{{totDetail[j] += quickcountMode ? parseInt(detail.quickcount ? detail.quickcount : 0) :parseInt(detail.suara?detail.suara:0)}}</span>
                          </td>
                        </tr>
                        <tr v-if="item.mode===2 && item.calons[i+1] && !item.calons[i+1].parent_id">
                          <td colspan="3" style="background:#ddd">Total Suara {{name}}</td>
                          <th style="background:#ddd">{{total}}</th>
                          <td style="background:#ddd" v-for="(detail, j) in calon.detail">{{totDetail[j]}}</td>
                        </tr>
                        <tr v-else-if="item.mode===2 && !item.calons[i+1]">
                          <td colspan="3" style="background:#ddd">Total Suara {{name}}</td>
                          <th style="background:#ddd">{{total}}</th>
                          <td style="background:#ddd" v-for="(detail, j) in calon.detail">{{totDetail[j]}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>  
                </v-card-text>
              </v-card>                              
            </v-expansion-panel-content>
          </v-expansion-panel>  
        </v-card-text>
      </v-card>
    </v-container>  
  </v-slide-y-transition>  
</template>
<script>
import Table2Excel from 'table2excel.js';  
import Model from '@/apps/frc/models/Report';   
const  model = new Model();  
  
export default {
  components: {
    
  },
  data: () => ({
    quickcountMode:false,
    tingkat:3,
    areas: [],
    area_id : null,
    areaLoading : false,
    areaSearch : null,
    kompetisisTemp : [],
    kompetisis: [],
    kompetisi_ids: [],
    kompetisiLoading : false,
    loading: false,
    result:[],
    panel:[],
    totDetail: []
  }),
  watch:{
    areaSearch(newVal){
      if(newVal){
        if(!this.area_id){
          const ctx=this; setTimeout(function(){
            ctx.areaLoading = true;
            if(newVal === ctx.areaSearch){
              model.kecamatans({'KecamatanSearch[name]':newVal}).then(res=>{                
                ctx.areas = res.status === 200 ? res.data.data:[];
                ctx.areaLoading = false;
              })
            }
          },700);        
        } 
      } else {
        this.area_id = null;
      }
    },
    area_id(newVal){
      if(newVal){
        model.kompetisisByArea({tingkat:this.tingkat,area_id:newVal}).then(res=>{          
          this.kompetisis = res.data;
          this.kompetisisTemp = res.data;
          if(this.kompetisi_ids.length > 0){
            this.setReport();
          }
        });
      }
    },
    kompetisi_ids(newVal){
      if(newVal.length > 0){        
        const ctx=this; setTimeout(function(){
          //console.log(ctx.kompetisis);
          if(newVal == ctx.kompetisi_ids){
            ctx.setReport();
          }          
        }, 1000);
      }
    }
  },  
  mounted(){
    this.init();
  },
  methods:{
    init(){
      if(this.$route.query.area_id){
        this.area_id = parseInt(this.$route.query.area_id);
        this.areaLoading = true;
        model.kecamatans({'KecamatanSearch[id]':this.area_id}).then(res=>{                
          this.areas = res.status === 200 ? res.data.data:[];
          this.areaLoading = false;
          
          if(this.$route.query.kompetisi_ids){
            let tempids = this.$route.query.kompetisi_ids;
            let ids = Array.isArray(tempids) ? tempids : [tempids];
            model.kompetisisByArea({tingkat:this.tingkat,area_id:this.area_id}).then(res=>{          
              this.kompetisis = res.data;          
              this.kompetisis.forEach(item=>{
                if(ids.includes(item.id)||ids.includes(item.id.toString())){
                  this.kompetisi_ids.push(item.name);
                }
              });              
            });
          }
        })
      }
    },
    
    setReport(){
      let ids = [];      
      this.kompetisi_ids.forEach(item=>{        
        let id = this.kompetisis.find(x => x.name === item)?this.kompetisis.find(x => x.name === item).id:null;        
        if(id)ids.push(id);
      });
      this.result = [];
      this.loading = true;
      
      this.$router.push({path:this.$route.path, query:{area_id:this.area_id,kompetisi_ids:ids}});
      model.da1({kecamatan_id:this.area_id,kompetisi_ids:ids}).then(res=>{
        if(res.status === 200){
          this.result = res.data;
        }
        this.panel   = [true];
        this.loading = false;
      });      
    },
    
    downloadExcel(){
      let filename = 'DA1 '+this.areas.find(x => x.id === this.area_id).name;
      new Table2Excel('.report'/*,{
        plugins: [{
          worksheetCompleted ({ workbook, tables, worksheet, table }) {            
            worksheet.name = table.getAttribute("name");
            //worksheet.getRow(1).hidden = true
            //worksheet.getColumn(1).hidden = true
          }
        }]
      }*/).export(filename); 
    },
    
    customFilter (item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      //const textTwo = item.abbr.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1; 
    },   
  }
};
</script>
<style>
.report {
  border-collapse: collapse;
  min-width: 100%;
}

.report th,.report td {
  border: 1px solid #ccc;
  padding: 5px 8px;
}
</style>

